/**
 * Inking Features panel — controls which feature detectors
 * contribute to stroke generation and their sensitivity.
 */

import {
  DEFAULT_INKING_MODE_SETTINGS,
  DEFAULT_INKING_SETTINGS,
} from "../../app/inkingDefaults.ts";
import { useStore } from "../../app/store.ts";
import { SectionLabel, SliderRow, Toggle } from "../shared.tsx";

export function InkingFeaturesPanelBody() {
  const im = useStore((s) => s.inkingMode);
  const setFeature = useStore((s) => s.setInkingFeatureEnabled);
  const setCreaseAngle = useStore((s) => s.setInkingCreaseAngle);
  const detail = useStore((s) => s.inkingDetail);
  const setDetail = useStore((s) => s.setInkingDetail);

  if (!im) return null;

  return (
    <>
      <SectionLabel>Feature Layers</SectionLabel>
      <Toggle
        label="Silhouettes"
        checked={im.features.silhouette}
        onChange={(v) => setFeature("silhouette", v)}
      />
      <Toggle
        label="Creases"
        checked={im.features.crease}
        onChange={(v) => setFeature("crease", v)}
      />
      {im.features.crease && (
        <SliderRow
          label="Crease Angle"
          value={im.creaseAngle}
          min={0}
          max={180}
          step={1}
          displayValue={`${Math.round(im.creaseAngle)}°`}
          onChange={setCreaseAngle}
          defaultValue={DEFAULT_INKING_MODE_SETTINGS.creaseAngle}
        />
      )}
      <Toggle
        label="Screen Edges"
        checked={im.features.screenEdges}
        onChange={(v) => setFeature("screenEdges", v)}
      />
      {im.features.screenEdges && (
        <SliderRow
          label="Edge Detail"
          value={detail}
          min={0}
          max={1}
          step={0.05}
          displayValue={`${Math.round(detail * 100)}%`}
          onChange={setDetail}
          defaultValue={DEFAULT_INKING_SETTINGS.detail}
        />
      )}
    </>
  );
}
